<template>
  <div class="normalModule">
    <emptyModule>
      <div class="bar">
        <span> </span>
        <span> </span>
      </div>
      <h3>{{ title }}</h3>
      <section><slot name="main"></slot></section>
      <footer><slot name="footer"></slot></footer>
    </emptyModule>
  </div>
</template>

<script>
import emptyModule from "./emptyModule.vue";
export default {
  name: "normalModule",
  components: {
    emptyModule,
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
  },
};
</script>

<style lang="less">
.normalModule {
  width: 622px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  div.bar {
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    span {
      display: inline-block;

      width: 16px;
      height: 14px;
      background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);

      &:first-child {
        margin-left: -16px;
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
      }

      &:last-child {
        margin-right: -16px;
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
      }
    }
  }
  h3 {
    position: relative;
    height: 88px;
    background: #e4f1fd;
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    text-align: center;
    line-height: 88px;
    margin-bottom: 10px;
  }
}
</style>
